export default {
  'printSetting.title': '打印关系',
  'printSetting.noPrinters': '暂无打印机',
  'printSetting.action.selectAll': '全选',
  'printSetting.action.revertAll': '全部反选',
  'printSetting.action.viewBindingPrinter': '查看绑定的打印机',
  'printSetting.saveModal.title': '是否确定保留如下变动?',
  'printSetting.noDishes': '所有菜品均处于绑定状态',
  'printSetting.saveSuccess': '保存成功',
  'printSetting.saveFailed': '保存失败',

  'printSetting.switchModal.title': '请选择绑定的打印机对象：',

  'printSetting.switch.title': '以下菜品转移至',
  'printSetting.unAssignedDishes.title': '新增未分配菜品:',
};
